<template>
  <div class="flex items-center gap-2">
    <button
      @click="$emit('decrease')"
      :disabled="quantity <= 1"
      class="w-8 h-8 rounded-full border flex items-center justify-center font-bold"
      :class="{
        'opacity-50 cursor-not-allowed': quantity <= 1,
        'hover:bg-gray-100': quantity > 1
      }"
    >
      -
    </button>
    <span class="w-8 text-center font-bold">{{ quantity }}</span>
    <button
      @click="$emit('increase')"
      class="w-8 h-8 rounded-full bg-primary text-white flex items-center justify-center font-bold hover:bg-primary-dark"
    >
      +
    </button>
  </div>
</template>

<script setup>
defineProps({
  quantity: {
    type: Number,
    default: 1,
    validator: (value) => value >= 1
  }
});

defineEmits(['increase', 'decrease']);
</script>
